import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { ref, onMounted } from "vue";
import { cloneDeep } from "lodash";
import { getResourceList } from "@/api/menuMangeApi";
import { message, Modal } from "ant-design-vue";
import { queryAllUserRoles, editUserPerms, editRolePerms } from "@/api/permission";
export const useAuthinfo = () => {
  const searchValue = ref("");
  const userSearchValue = ref("");
  const roleSearchValue = ref("");
  const tableKeyRandom = ref(Math.random());
  // 权限菜单
  const permissionGroups = ref([]);
  // 当前选中权限
  const currentCheckedKeys = ref([]);
  // 当前选中菜单对应权限列表
  const currentCheckMenuAuthorityList = ref([]);
  // 当前选中菜单对应选中权限id
  const currentCheckMenuPermissionId = ref("");
  // 当前选中菜单对应菜单层级
  const currentCheckMenuResType = ref(null);
  // 当前权限对应的用户列表
  const currentPersimmonUserList = ref({
    roleInfos: [],
    userInfos: []
  });
  const originPersimmonUserList = ref({
    roleInfos: [],
    userInfos: []
  });
  const page = ref({
    pageIndex: 1,
    pageSize: 10
  });
  const tableLoading = ref(false);
  // 展开的节点
  const expandedKeys = ref([]);
  const currentType = ref(["role"]);
  const menuItems = ref([{
    label: "已授权的角色",
    key: "role"
  }, {
    label: "已授权的用户",
    key: "user"
  }]);
  const roleColumns = [{
    title: "角色名称",
    dataIndex: "roleName",
    key: "roleName",
    align: "left"
  }, {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
    width: "200px",
    align: "left"
  }];
  const userColumns = [{
    title: "账号",
    dataIndex: "name",
    key: "name",
    align: "left"
  }, {
    title: "姓名",
    dataIndex: "username",
    key: "username",
    align: "left"
  }, {
    title: "已授权角色",
    dataIndex: "roleNames",
    key: "roleNames",
    align: "left"
  }, {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
    width: "200px",
    align: "left"
  }];
  // 判断是否为一级菜单节点
  const isFirstLevelNode = nodeId => {
    return permissionGroups.value.some(item => item.id === nodeId);
  };
  // 判断是否为二级菜单节点
  const isSecondLevelNode = nodeId => {
    for (const firstLevel of permissionGroups.value) {
      if (firstLevel.items && firstLevel.items.some(item => item.id === nodeId)) {
        return true;
      }
    }
    return false;
  };
  const handleMenuClick = () => {
    page.value.pageIndex = 1;
    tableKeyRandom.value = Math.random();
  };
  // 处理节点点击
  const handleNodeClick = (event, item) => {
    event.stopPropagation(); // 阻止事件冒泡
    // 如果是一级菜单节点
    if (isFirstLevelNode(item.data.id)) {
      if (expandedKeys.value.includes(item.data.id)) {
        expandedKeys.value = expandedKeys.value.filter(i => i !== item.data.id);
      } else {
        expandedKeys.value = [...expandedKeys.value, item.data.id];
      }
    }
    // 如果是二级菜单节点
    else if (isSecondLevelNode(item.data.id)) {
      // 直接选中点击的二级菜单
      currentCheckedKeys.value = [item.data.id];
      currentCheckMenuAuthorityList.value = item.data.children ? item.data.children : [];
      currentCheckMenuPermissionId.value = item.data.children ? item.data.children[0].permissionId : "";
      getAuthorityUserTableList();
    }
  };
  const handleSearchMenu = () => {
    page.value.pageIndex = 1;
    const value = searchValue.value.trim();
    if (!value) {
      // 如果搜索内容为空，恢复原始数据
      fetchResourceList();
      return;
    }
    // 对菜单进行搜索过滤
    const filteredPermissionGroups = cloneDeep(permissionGroups.value);
    // 遍历过滤一级菜单和二级菜单
    const result = filteredPermissionGroups.filter(firstLevel => {
      // 保留名称匹配的一级菜单
      if (firstLevel.name.includes(value)) return true;
      // 过滤二级菜单
      if (firstLevel.items && firstLevel.items.length) {
        firstLevel.items = firstLevel.items.filter(secondLevel => {
          return secondLevel.name.includes(value);
        });
        // 如果二级菜单有匹配项，则保留该一级菜单
        return firstLevel.items.length > 0;
      }
      return false;
    });
    // 更新菜单数据
    permissionGroups.value = result;
    // 如果有匹配结果，自动展开所有一级菜单
    if (result.length > 0) {
      expandedKeys.value = result.map(item => item.id);
      // 自动选中第一个匹配的二级菜单（如果有）
      for (const group of result) {
        if (group.items && group.items.length > 0) {
          var _group$items$0$childr;
          currentCheckedKeys.value = [group.items[0].id];
          currentCheckMenuAuthorityList.value = group.items[0].children ? group.items[0].children : [];
          currentCheckMenuPermissionId.value = group.items[0].children ? ((_group$items$0$childr = group.items[0].children[0]) === null || _group$items$0$childr === void 0 ? void 0 : _group$items$0$childr.permissionId) || "" : "";
          getAuthorityUserTableList();
          break;
        }
      }
    } else {
      // 如果没有搜索结果，清空选中状态
      currentCheckedKeys.value = [];
      currentCheckMenuAuthorityList.value = [];
      currentCheckMenuPermissionId.value = "";
    }
  };
  const handleAuthorityClick = item => {
    currentCheckMenuResType.value = item.resType;
    currentCheckMenuPermissionId.value = item.permissionId;
    getAuthorityUserTableList();
  };
  // 查询权限列表
  const getAuthorityUserTableList = async () => {
    tableLoading.value = true;
    const {
      code,
      data
    } = await queryAllUserRoles({
      permissionId: currentCheckMenuPermissionId.value
    });
    tableLoading.value = false;
    if (code === "0" && data) {
      currentPersimmonUserList.value = data;
      originPersimmonUserList.value = cloneDeep(data);
      page.value.pageIndex = 1;
    } else {
      currentPersimmonUserList.value = {
        roleInfos: [],
        userInfos: []
      };
      originPersimmonUserList.value = {
        roleInfos: [],
        userInfos: []
      };
    }
  };
  const handleUserSearchRoleTable = () => {
    if (userSearchValue.value) {
      const tableListCopy = cloneDeep(originPersimmonUserList.value);
      currentPersimmonUserList.value.userInfos = tableListCopy.userInfos.filter(i => i.name.includes(userSearchValue.value.trim()) || i.username.includes(userSearchValue.value.trim()));
    } else {
      currentPersimmonUserList.value.userInfos = originPersimmonUserList.value.userInfos;
    }
  };
  const handleRoleSearchRoleTable = () => {
    if (roleSearchValue.value) {
      const tableListCopy = cloneDeep(originPersimmonUserList.value);
      currentPersimmonUserList.value.roleInfos = tableListCopy.roleInfos.filter(i => i.roleName.includes(roleSearchValue.value.trim()));
    } else {
      currentPersimmonUserList.value.roleInfos = originPersimmonUserList.value.roleInfos;
    }
  };
  const handleCancelAuth = async record => {
    if (currentType.value[0] === "role") {
      Modal.confirm({
        title: "提示",
        content: "确定要取消角色授权吗？",
        onOk: async () => {
          // 角色
          const permissionIds = currentCheckMenuResType.value !== 2 ? record.permId.split(",").filter(i => Number(i) !== Number(currentCheckMenuPermissionId.value)) : record.permId.split(",").filter(i => !currentCheckMenuAuthorityList.value.some(item => Number(item.permissionId) === Number(i)));
          const {
            code
          } = await editRolePerms({
            rid: record.id,
            pid: permissionIds.join(",")
          });
          if (code === "0000") {
            message.success("权限修改成功");
            getAuthorityUserTableList();
          }
        }
      });
    } else {
      Modal.confirm({
        title: "提示",
        content: "确定要取消用户授权吗？",
        onOk: async () => {
          // 用户
          const permissionIds = currentCheckMenuResType.value !== 2 ? record.permId.split(",").filter(i => Number(i) !== Number(currentCheckMenuPermissionId.value)) : record.permId.split(",").filter(i => !currentCheckMenuAuthorityList.value.some(item => Number(item.permissionId) === Number(i)));
          const {
            code
          } = await editUserPerms({
            uid: record.id,
            pid: permissionIds.join(",")
          });
          if (code === "0000") {
            message.success("权限修改成功");
            getAuthorityUserTableList();
          }
        }
      });
    }
  };
  // 获取权限资源列表
  const fetchResourceList = async () => {
    try {
      const {
        code,
        data
      } = await getResourceList();
      if (code === "0" && data) {
        let resDataList = data.map(item => ({
          id: item.id,
          name: item.name,
          permissionId: item.permissionId,
          permission: item.permission,
          items: item.children || []
        }));
        resDataList = resDataList.filter(item => {
          var _item$items;
          return (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length;
        }).map(item => {
          return {
            ...item,
            items: item.items.map(e => {
              return {
                ...e,
                children: [{
                  ...e,
                  name: `${e.name}（菜单）`
                }, ...e.children]
              };
            })
          };
        });
        permissionGroups.value = resDataList;
        expandedKeys.value = [resDataList[0].id];
        // 初始默认选中第一个一级菜单的第一个二级菜单
        if (resDataList.length > 0 && resDataList[0].items && resDataList[0].items.length > 0) {
          currentCheckedKeys.value = [resDataList[0].items[0].id];
          currentCheckMenuAuthorityList.value = resDataList[0].items[0].children ? resDataList[0].items[0].children : [];
          currentCheckMenuPermissionId.value = resDataList[0].items[0].children ? resDataList[0].items[0].children[0].permissionId : "";
          currentCheckMenuResType.value = resDataList[0].items[0].resType;
          getAuthorityUserTableList();
        }
      }
    } catch (error) {
      console.error("获取权限资源列表失败", error);
    }
  };
  const handlePageChange = pageIndex => {
    page.value.pageIndex = pageIndex;
  };
  const handlePageSizeChange = (current, pageSize) => {
    page.value.pageIndex = 1;
    page.value.pageSize = pageSize;
  };
  // 分页截取数据
  const paginationData = computed(() => {
    const currentTableData = currentType.value[0] === 'role' ? cloneDeep(currentPersimmonUserList.value.roleInfos) : cloneDeep(currentPersimmonUserList.value.userInfos);
    const start = (page.value.pageIndex - 1) * page.value.pageSize;
    const end = start + page.value.pageSize;
    return currentTableData.slice(start, end);
  });
  // 生命周期钩子
  onMounted(async () => {
    await fetchResourceList();
  });
  return {
    permissionGroups,
    currentCheckedKeys,
    currentCheckMenuAuthorityList,
    currentCheckMenuPermissionId,
    currentPersimmonUserList,
    originPersimmonUserList,
    tableLoading,
    expandedKeys,
    currentType,
    menuItems,
    roleColumns,
    userColumns,
    page,
    isFirstLevelNode,
    isSecondLevelNode,
    handleMenuClick,
    handleNodeClick,
    handleSearchMenu,
    handleAuthorityClick,
    getAuthorityUserTableList,
    handleUserSearchRoleTable,
    handleRoleSearchRoleTable,
    handleCancelAuth,
    fetchResourceList,
    searchValue,
    userSearchValue,
    roleSearchValue,
    tableKeyRandom,
    handlePageChange,
    handlePageSizeChange,
    paginationData
  };
};